import React from 'react';

export default () => {
  const urlParams = new URLSearchParams(window.location.search);
  const type = urlParams.get('type') || 'primary';
  const message = urlParams.get('message');
  const typeClass = `alert alert-${type}`;

  if (!message) {
    return null;
  }

  return (
    <div className={typeClass} role="alert">
      {message}
    </div>
  );
};
